import { useAuth } from '../auth/AuthContext';
import { homeFor, PROVIDER_ROOT } from './portal';

/**
 * Where the advert screens live for whoever is looking (156).
 *
 * A landlord edits adverts inside the landlord app (/listings, /vacancies).
 * Somebody from the public who signed up to post uses the same screens inside
 * their own "My listings" area, because the landlord app is not theirs. The
 * screens are shared; only the links between them differ.
 */
export function useListingPaths() {
  const { roles } = useAuth();
  const publicPoster = homeFor(roles) === PROVIDER_ROOT;
  const base = publicPoster ? '/my-listings/homes' : '/listings';
  return {
    publicPoster,
    listing: (id: string) => `${base}/${id}`,
    promote: (id: string) => `${base}/${id}/promote`,
    newExternal: `${base}/new?external=1`,
    bundles: publicPoster ? '/my-listings/homes/bundles' : '/listing-bundles',
    home: publicPoster ? '/my-listings' : '/vacancies',
  };
}

/** The same for sale adverts: /sale-listings in the landlord app, /my-listings/sales for the public. */
export function useSalePrefix() {
  const { roles } = useAuth();
  return homeFor(roles) === PROVIDER_ROOT ? '/my-listings/sales' : '/sale-listings';
}
